import { Notification } from '@/components/admin/notification';
import { LoginForm } from '@/components/ui/login-form.tsx';

export const LoginPage = () => {
  return (
    <div className="relative flex min-h-svh flex-col items-center justify-center gap-6 overflow-hidden p-6 md:p-10">
      {/* Ambient aurora backdrop — soft brand blobs for a premium first
          impression. Mirrors AuthPageWrapper. Purely decorative. */}
      <div aria-hidden className="pointer-events-none absolute inset-0">
        <div
          className="absolute left-1/2 top-0 size-[520px] -translate-x-1/2 -translate-y-1/3 rounded-full opacity-[0.13] blur-[150px]"
          style={{ background: 'var(--gl-violet)' }}
        />
        <div
          className="absolute bottom-0 left-1/4 size-[440px] translate-y-1/3 rounded-full opacity-[0.11] blur-[150px]"
          style={{ background: 'var(--gl-cobalt)' }}
        />
        <div
          className="absolute right-0 top-1/3 size-[400px] translate-x-1/3 rounded-full opacity-[0.08] blur-[150px]"
          style={{ background: 'var(--gl-emerald)' }}
        />
      </div>
      <div className="relative flex w-full max-w-sm flex-col gap-6">
        <LoginForm type="login" />
      </div>
      <Notification />
    </div>
  );
};
